import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fd86cce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Подпись должна быть на прозрачном фоне в формате png", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Перенесите сюда "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" подпись или нажмите "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" для загрузки")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Перенесите сюда "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" подпись или нажмите "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" для загрузки")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "filenameSpan" }
const _hoisted_7 = {
  key: 0,
  class: "dots-container"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"dot\" data-v-3fd86cce></div><div class=\"dot\" data-v-3fd86cce></div><div class=\"dot\" data-v-3fd86cce></div><div class=\"dot\" data-v-3fd86cce></div><div class=\"dot\" data-v-3fd86cce></div>", 5)
const _hoisted_13 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Trash = _resolveComponent("Trash")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("input", {
      ref: "upload_file",
      type: "file",
      hidden: "",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitFile(_ctx.file_upload_name)))
    }, null, 544),
    _createElementVNode("div", {
      ref: "fileformuploaded",
      class: _normalizeClass(["uploadFile", _ctx.document[_ctx.file_upload_name] == '' ? 'uploadhide' : '']),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.upload_file.click())),
      style: _normalizeStyle('background: url(\'https://api.rekprof.ru/files/'+_ctx.document[_ctx.file_upload_name]+'?a='+_ctx.unicFile+'\'); background-position: center; background-size: contain; background-repeat: no-repeat; border: 1px solid black;')
    }, _hoisted_3, 6),
    _createElementVNode("div", {
      ref: "fileform",
      class: _normalizeClass(["uploadFile", _ctx.document[_ctx.file_upload_name] != '' ? 'uploadhide' : '']),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.upload_file.click()))
    }, _hoisted_5, 2),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.document[_ctx.file_upload_name]==''?'не загружен':_ctx.document[_ctx.file_upload_name].split("/")[_ctx.document[_ctx.file_upload_name].split("/").length-1]), 1),
      (_ctx.document[_ctx.file_upload_name]!='')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "downloadSpan",
            onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+_ctx.route.query.id+'&hash='+_ctx.route.query.hash+'&type=fileupload&filename='+_ctx.file_upload_name, _ctx.document[_ctx.file_upload_name].split('/')[_ctx.document[_ctx.file_upload_name].split('/').length-1]);})
          }, "Скачать"))
        : _createCommentVNode("", true),
      (_ctx.document[_ctx.file_upload_name]!='')
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "delSpan",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitFile(_ctx.file_upload_name, '1')))
          }, [
            _createVNode(_component_Trash)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.proc_upload)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, _hoisted_13))
      : _createCommentVNode("", true)
  ], 64))
}